module.exports = __webpack_public_path__ + "6b3980648cf941f65d74ad50a43938a6.MP3";